import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";
import * as types from "./strategicCapsVsDemandActionType";
import * as actions from "./strategicCapsVsDemandAction";
import * as services from "./strategicCapsVsDemandServices";
import { downloadBase64File } from "../../../../utils/fileDownloads";

// Notes Edit Saga
function* fetchStrategicCapsNotesEditSaga(action) {
  try {
    const response = yield call(
      services.getStrategicCapsNotesEditData,
      action.payload,
    );
    yield put(actions.fetchStrategicCapsNotesEditSuccess(response));
  } catch (error) {
    yield put(actions.fetchStrategicCapsNotesEditFailure(error.message));
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to fetch Notes data",
    });
  }
}

// Notes Save Saga
function* fetchStrategicCapsNotesSaveSaga(action) {
  try {
    const response = yield call(
      services.saveStrategicCapsNotesData,
      action.payload,
    );
    yield put(actions.fetchStrategicCapsNotesSaveSuccess(response));
    Swal.fire({
      icon: "success",
      title: "Success",
      text: "Notes saved successfully",
    });
  } catch (error) {
    yield put(actions.fetchStrategicCapsNotesSaveFailure(error.message));
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to save Notes data",
    });
  }
}

// Delete Report Saga
function* deleteStrategicCapsReportSaga(action) {
  try {
    const response = yield call(
      services.deleteStrategicCapsReport,
      action.payload.id,
    );
    if (response?.success) {
      yield put(actions.deleteStrategicCapsReportSuccess(response));
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: response?.resultMessage || "Report deleted successfully",
      });
      yield put(
        actions.fetchStrategicCapsReportsRequest({
          SkipNoOfRecords: 0,
          PageSize: 100,
          sSearch: '',
          sortColumn: "BlockPlanningCapsVsDemandTableID",
          sortColumnDir: "desc",
        }),
      );
    }
  } catch (error) {
    yield put(actions.deleteStrategicCapsReportFailure(error.message));
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error?.message || "Failed to delete report",
    });
  }
}

// Export Report Saga
function* exportStrategicCapsReportSaga(action) {
  try {
    const response = yield call(
      services.exportStrategicCapsReport,
      action.payload.id,
    );

    // Get base64 data from response
    const base64Data = response?.values || response;
    const fileName =
      action.payload.fileName || "Strategic_Capacity_vs_Demand_Report";

    yield call(
      downloadBase64File,
      base64Data,
      "StrategicCapsVsDemand",
      fileName,
    );
    yield put(actions.exportStrategicCapsReportSuccess(response));
  } catch (error) {
    console.error("Export error:", error);
    yield put(actions.exportStrategicCapsReportFailure(error.message));
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to export report",
    });
  }
}

// Fetch Reports Saga
function* fetchStrategicCapsReportsSaga(action) {
  try {
    const response = yield call(
      services.getStrategicCapsReportsWithPagination,
      action.payload,
    );
    yield put(actions.fetchStrategicCapsReportsSuccess(response));
  } catch (error) {
    yield put(actions.fetchStrategicCapsReportsFailure(error.message));
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to fetch reports",
    });
  }
}

// Fetch Dropdown Saga
function* fetchStrategicCapsDropdownSaga() {
  try {
    const response = yield call(services.getStrategicCapsDropdownData);
    yield put(actions.fetchStrategicCapsDropdownSuccess(response));
  } catch (error) {
    yield put(actions.fetchStrategicCapsDropdownFailure(error.message));
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to fetch dropdown data",
    });
  }
}

// Fetch FilterDropdown Saga
function* fetchFilterStrategicCapsDropdownSaga() {
  try {
    const response = yield call(services.getFilterStrategicCapsDropdownData);
    yield put(actions.fetchFilterStrategicCapsDropdownSuccess(response));
  } catch (error) {
    yield put(actions.fetchFilterStrategicCapsDropdownFailure(error.message));
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to fetch dropdown data",
    });
  }
}

// weekQuarter Saga
function* WeekQuarterCapsDropdownRequest(action) {
  try {
    const response = yield call(
      services.getWeekQuarterCapsDropdownData,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchWeekQuarterCapsDropdownSuccess(response));
    } else {
      yield put(
        actions.fetchWeekQuarterCapsDropdownFailure(
          response?.errorMessage || "Failed to fetch week/quarter data",
        ),
      );
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response?.errorMessage || "Failed to fetch week/quarter data",
      });
    }
  } catch (error) {
    yield put(actions.fetchWeekQuarterCapsDropdownFailure(error.message));
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to fetch week/quarter data.",
    });
  }
}

// Fetch wRVU Surplus Worklist View Table Saga
function* fetchWRVUSurplusWorklistSaga(action) {
  try {
    const response = yield call(
      services.getWRVUSurplusWorklistData,
      action.payload,
    );
    yield put(actions.fetchWRVUSurplusWorklistSuccess(response));
  } catch (error) {
    yield put(actions.fetchWRVUSurplusWorklistFailure(error.message));
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to fetch wRVU Surplus Worklist View data",
    });
  }
}

// Fetch wRVU Surplus (Gap) View Table Saga
function* fetchWRVUSurplusSaga(action) {
  try {
    const response = yield call(services.getWRVUSurplusData, action.payload);
    yield put(actions.fetchWRVUSurplusSuccess(response));
  } catch (error) {
    yield put(actions.fetchWRVUSurplusFailure(error.message));
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to fetch wRVU Surplus (Gap) View data",
    });
  }
}

// Fetch FTE Surplus (Gap) View Table Saga
function* fetchFTESurplusSaga(action) {
  try {
    const response = yield call(services.getFTESurplusData, action.payload);
    yield put(actions.fetchFTESurplusSuccess(response));
  } catch (error) {
    yield put(actions.fetchFTESurplusFailure(error.message));
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to fetch FTE Surplus (Gap) View data",
    });
  }
}

// Fetch Legend Saga
function* fetchLegendSaga() {
  try {
    const response = yield call(services.getLegendData);
    yield put(actions.fetchLegendSuccess(response));
  } catch (error) {
    yield put(actions.fetchLegendFailure(error.message));
    console.error("Failed to fetch legend data:", error);
  }
}

// Draft Saga
function* draftStrategicCapsSaga(action) {
  try {
    const response = yield call(
      services.draftStrategicCapsReport,
      action.payload,
    );

    if (response?.success) {
      yield put({ type: types.DRAFT_STRATEGIC_CAPS_SUCCESS });

      Swal.fire({
        title: "Success",
        text: response?.resultMessage || "Report saved as draft successfully",
        icon: "success",
      });
    } else {
      yield put({ type: types.DRAFT_STRATEGIC_CAPS_FAILURE });
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response?.errorMessage || "Saving draft failed.",
      });
    }
  } catch (error) {
    yield put({ type: types.DRAFT_STRATEGIC_CAPS_FAILURE });
    Swal.fire({ icon: "error", title: "Error", text: "Failed to save draft." });
  }
}

// Publish Saga
function* publishStrategicCapsSaga(action) {
  try {
    const response = yield call(
      services.publishStrategicCapsReport,
      action.payload,
    );

    if (response?.success) {
      yield put({ type: types.PUBLISH_STRATEGIC_CAPS_SUCCESS });

      Swal.fire({
        title: "Success",
        text: response?.resultMessage || "Report published successfully",
        icon: "success",
      });
    } else {
      yield put({ type: types.PUBLISH_STRATEGIC_CAPS_FAILURE });
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response?.errorMessage || "Publishing failed.",
      });
    }
  } catch (error) {
    yield put({ type: types.PUBLISH_STRATEGIC_CAPS_FAILURE });
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to publish report.",
    });
  }
}

// filter Apply Saga
function* filterStrategicCapsApplySaga(action) {
  try {
    const response = yield call(
      services.filterStrategicCapsApplyReport,
      action.payload,
    );

    if (response?.success) {
      yield put({ type: types.FILTER_STRATEGIC_CAPS_APPLY_SUCCESS });

      Swal.fire({
        title: "Success",
        text: response?.resultMessage || "Report applied successfully",
        icon: "success",
      });
    } else {
      yield put({ type: types.FILTER_STRATEGIC_CAPS_APPLY_FAILURE });
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response?.errorMessage || "Applying filter failed.",
      });
    }
  } catch (error) {
    yield put({ type: types.FILTER_STRATEGIC_CAPS_APPLY_FAILURE });
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to apply filter.",
    });
  }
}

// get Worklist By RPCEID Saga
function* getWorklistByRPCEIDSaga(action) {
  try {
    const response = yield call(services.getWorklistByRPCEID, action.payload);

    if (response?.success) {
      yield put({
        type: types.GET_WORKLIST_BY_RPCEID_SUCCESS,
        payload: response,
      });
    } else {
      yield put({ type: types.GET_WORKLIST_BY_RPCEID_FAILURE });
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response?.errorMessage || "Get WorkList By RPCEID failed.",
      });
    }
  } catch (error) {
    yield put({ type: types.GET_WORKLIST_BY_RPCEID_FAILURE });
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Get WorkList By RPCEID failed.",
    });
  }
}

// Get BlockPlanningCapacityVsDemandTableReport Saga
function* GetBlockPlanningCapacityVsDemandTableReportSaga(action) {
  try {
    const response = yield call(
      services.getBlockPlanningCapacityVsDemandTableReport,
      action.payload,
    );

    if (response?.success) {
      yield put({
        type: types.GET_STRATEGIC_CAPS_VS_DEMAND_SUCCESS,
        payload: response,
      });
    } else {
      yield put({ type: types.GET_STRATEGIC_CAPS_VS_DEMAND_FAILURE });
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response?.errorMessage || "Publishing failed.",
      });
    }
  } catch (error) {
    yield put({ type: types.GET_STRATEGIC_CAPS_VS_DEMAND_FAILURE });
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to publish report.",
    });
  }
}
function* fetchCapsDemandFilterByIdSaga(action) {
  try {
    const response = yield call(
      services.getCapsVsDemandFilterByID,
      action.payload,
    );

    if (response?.success) {
      yield put(
        actions.fetchCapsDemandFilterByIdSuccess(response.values || {}),
      );
    } else {
      yield put(
        actions.fetchCapsDemandFilterByIdFailure(
          response?.errorMessage || "Failed to load filters",
        ),
      );
    }
  } catch (error) {
    yield put(
      actions.fetchCapsDemandFilterByIdFailure(
        error.message || "Failed to load filters",
      ),
    );
  }
}

// Watcher Saga
export default function* strategicCapsVsDemandSaga() {
  yield takeLatest(
    types.FETCH_STRATEGIC_CAPS_NOTES_EDIT_REQUEST,
    fetchStrategicCapsNotesEditSaga,
  );
  yield takeLatest(
    types.FETCH_STRATEGIC_CAPS_NOTES_SAVE_REQUEST,
    fetchStrategicCapsNotesSaveSaga,
  );
  yield takeLatest(
    types.DELETE_STRATEGIC_CAPS_REPORT_REQUEST,
    deleteStrategicCapsReportSaga,
  );
  yield takeLatest(
    types.EXPORT_STRATEGIC_CAPS_REPORT_REQUEST,
    exportStrategicCapsReportSaga,
  );
  yield takeLatest(
    types.FETCH_STRATEGIC_CAPS_REPORTS_REQUEST,
    fetchStrategicCapsReportsSaga,
  );
  yield takeLatest(
    types.FETCH_STRATEGIC_CAPS_DROPDOWN_REQUEST,
    fetchStrategicCapsDropdownSaga,
  );
  yield takeLatest(
    types.FETCH_WRVU_SURPLUS_WORKLIST_REQUEST,
    fetchWRVUSurplusWorklistSaga,
  );
  yield takeLatest(types.FETCH_WRVU_SURPLUS_REQUEST, fetchWRVUSurplusSaga);
  yield takeLatest(types.FETCH_FTE_SURPLUS_REQUEST, fetchFTESurplusSaga);
  yield takeLatest(types.FETCH_LEGEND_REQUEST, fetchLegendSaga);
  yield takeLatest(types.DRAFT_STRATEGIC_CAPS_REQUEST, draftStrategicCapsSaga);
  yield takeLatest(
    types.PUBLISH_STRATEGIC_CAPS_REQUEST,
    publishStrategicCapsSaga,
  );
  yield takeLatest(
    types.GET_STRATEGIC_CAPS_VS_DEMAND_REQUEST,
    GetBlockPlanningCapacityVsDemandTableReportSaga,
  );
  yield takeLatest(
    types.FETCH_FILTER_STRATEGIC_CAPS_DROPDOWN_REQUEST,
    fetchFilterStrategicCapsDropdownSaga,
  );
  yield takeLatest(
    types.FETCH_WEEK_QUARTER_CAPS_DROPDOWN_REQUEST,
    WeekQuarterCapsDropdownRequest,
  );
  yield takeLatest(
    types.GET_WORKLIST_BY_RPCEID_REQUEST,
    getWorklistByRPCEIDSaga,
  );
  yield takeLatest(
    types.FILTER_STRATEGIC_CAPS_APPLY_REQUEST,
    filterStrategicCapsApplySaga,
  );
  yield takeLatest(
    types.FETCH_CAPS_DEMAND_FILTER_BY_ID_REQUEST,
    fetchCapsDemandFilterByIdSaga,
  );
}
